
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
    props: {
        // v-model="curPage" 로부터 전달 받음
        // value: {
        //     type: Number,
        //     default: null,
        // },
        // // 한블록 을 이룰 데이터 그룹 갯수 예) blockCount = items[[group],[group],[group],[group] ] =  4
        // blockCount: {
        //     type: Number,
        //     default: 0,
        // },
        // // 블록 의 크기 예) 5 = 1 2 3 4 5
        // blockSize: {
        //     type: Number,
        //     default: 5,
        // },
        // prev: Boolean,
        // next: Boolean,
        type2: Boolean,
    },

    data() {
        return {
        }
    },

    computed: {
        ...mapState('paging', [
            'pageCount',
            'curPage',
            'nextKey',
            'prevKey',
            'prevKeyList',
            'last'
        ]),
        ...mapGetters('paging', ['getViewCount']),
    },

    methods: {
        ...mapMutations('paging', ['SET_PAGE', 'SET_NEXT', 'SET_PREV', 'SET_LAST']),
        onClickPrev() {
            // this.SET_PREV()
            this.$emit('onClickPrev')
        },
        onClickNext() {
            // this.SET_NEXT()
            // this.SET_LAST()
            console.log('onClickNext')
            this.$emit('onClickNext')
        },

        onClickPage(page) {
            const realPage = page - 1
            // if (this.value !== val.Page) {

            // }
            if (this.curPage !== realPage) {
                this.SET_PAGE(realPage)
                this.$emit('clickPage')
            }
            console.log(this.nextKey)
        },
    },
}
